import styles from "./UserWidget.module.scss";
import ExitIcon from "@assets/icons/outline/log-out.svg?react";
import SecurityIcon from "@assets/icons/outline/lock-keyhole.svg?react";
import AutoIcon from "@assets/icons/outline/bot.svg?react";
import FinanceIcon from "@assets/icons/outline/wallet.svg?react";
import UserIcon from "@assets/icons/outline/circle-user-round.svg?react";
import ChevronDown from "@assets/icons/outline/chevron-down.svg?react";
import Avatar from "./Avatar.tsx";
import { MenuItem } from "./MenuItem";
import { HoverCard } from '@components/new/HoverCard';
import { Title2, SubTitle3 } from "@components/new/Typo";
import { useAuth } from "@contexts/AuthenticationContext";
import { useProfile } from "@contexts/ProfileContext";
import cn from "classnames";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const UserWidget = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { account } = useProfile();

  return (
    <HoverCard
      trigger="click"
      align="start"
      Action={({ isActive }) => (
        <div className={cn(styles.userWidget, isActive && styles.active)}>
          <Avatar text={account?.name ?? ""} />
          <div className={styles.name}>
            <Title2>{account?.name ?? ""}</Title2>
            {account?.email ? (
              <SubTitle3 color="grey-800">{account?.email ?? ""}</SubTitle3>
            ) : null}
          </div>
          <ChevronDown className={styles.chevron} />
        </div>
      )}
      Content={({ close }) => {
        const createClickHandler = (to: string) => () => {
          navigate(to);
          close();
        }
        const handleLogout = () => {
          auth.logout();
          close();
        }
        return (
          <div className={styles.hoverCard}>
            <MenuItem
              icon={UserIcon}
              title={t("userWidget.profile")}
              onClick={createClickHandler("/profile")}
            />
            <MenuItem
              icon={FinanceIcon}
              title={t("userWidget.finance")}
              onClick={createClickHandler("/profile?tab=finTab")}
            />
            {(account?.region === 'CN' ? (account?.isTestUser && account?.features.customerReturnsResales) : true) ? (
              <MenuItem
                icon={AutoIcon}
                title={t("userWidget.autoActions")}
                onClick={createClickHandler("/profile?tab=autoActionsTab")}
              />
            ) : null}
            {false ? (
              <MenuItem
                icon={SecurityIcon}
                title={t("userWidget.security")}
                onClick={createClickHandler("/profile")}
              />
            ) : null}
            <div className={styles.divider} />
            <MenuItem
              icon={ExitIcon}
              title={t("userWidget.logout")}
              onClick={handleLogout}
            />
          </div>
        )
      }}
    />
  );
};

export default UserWidget;
